<template>
  <section class="sidearm-mm-theme bg-black relative" data-anchor="theme">
    <div class="sidearm-mm-theme__inner relative">
      <div
        class="sidearm-mm-theme__layer sidearm-mm-theme__group absolute w-100 h-100"
        id="sidearm-mm-theme-glass-group"
      >
        <div class="h-100 w-100">
          <picture>
            <source
              srcset="~@/assets/themes/cinderella/glass-group.png"
              media="(min-width: 1025px)"
            />
            <img src="~@/assets/themes/cinderella/glass-group_mobile.png" />
          </picture>
        </div>
      </div>
      <div
        class="sidearm-mm-theme__layer sidearm-mm-theme__group-b absolute w-100 h-100"
        id="sidearm-mm-theme-glass-group-b"
      >
        <div class="h-100 w-100">
          <picture>
            <source
              srcset="~@/assets/themes/cinderella/glass-group-b.png"
              media="(min-width: 1025px)"
            />
            <img src="~@/assets/themes/cinderella/glass-group-b_mobile.png" />
          </picture>
        </div>
      </div>
      <div
        class="sidearm-mm-theme__layer sidearm-mm-theme__shoe absolute w-100 h-100"
        id="sidearm-mm-theme-glass-shoe"
      >
        <div class="h-100 w-100">
          <picture>
            <source
              srcset="~@/assets/themes/cinderella/glass-shoe.png"
              media="(min-width: 1025px)"
            />
            <img src="~@/assets/themes/cinderella/glass-shoe_mobile.png" />
          </picture>
        </div>
      </div>
      <div
        class="sidearm-mm-theme__layer sidearm-mm-theme__blur absolute w-100 h-100"
        id="sidearm-mm-theme-glass-blur-top"
      >
        <div class="h-100 w-100">
          <picture>
            <source
              srcset="~@/assets/themes/cinderella/glass-blur-top.png"
              media="(min-width: 1025px)"
            />
            <img src="~@/assets/themes/cinderella/glass-blur-top_mobile.png" />
          </picture>
        </div>
      </div>
      <div
        class="sidearm-mm-theme__layer sidearm-mm-theme__particle absolute w-100 h-100"
        id="sidearm-mm-theme-blue-particle"
      >
        <div class="h-100 w-100">
          <picture>
            <source
              srcset="~@/assets/themes/cinderella/glass-group.png"
              media="(min-width: 1025px)"
            />
            <img src="~@/assets/themes/cinderella/glass-group_mobile.png" />
          </picture>
        </div>
      </div>
      <div
        class="sidearm-mm-theme__title absolute w-100 h-100"
        id="sidearm-mm-theme-title"
      >
        <div class="h-100 w-100">
          <div class="sidearm-mm-theme__title-text hide-on-large-down">
            Shatter Expectations
          </div>
          <div class="sidearm-mm-theme__title-text hide-on-x-large">
            <div>Shatter</div>
            <div>Expectations</div>
          </div>
        </div>
      </div>
      <div
        class="sidearm-mm-theme__divider absolute w-100 h-100"
        id="sidearm-mm-theme-divider"
      >
        <div class="h-100 w-100">
          <div>
            <span></span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.sidearm-mm-theme {
  &__inner {
    height: 300vh;
  }
  &__shoe {
    img {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  &__blur {
    img {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translate(-50%, 0);
    }
  }
  &__group {
    img {
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translate(-50%, 50%);
    }
  }
  &__group-b {
    img {
      position: absolute;
      bottom: 0;
      right: 0;
      transform: translate(0, 50%);
    }
  }
  &__particle {
    img {
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translate(-50%, 100%);
    }
  }
  &__title-text {
    position: absolute;
    top: 0;
    left: 0;
    text-align: center;
    width: 100%;
    white-space: nowrap;
    font-family: $font-abolition;
    font-size: 6rem;
    letter-spacing: 0.45em;
    padding-left: 0.45em;
    line-height: 1;
    font-weight: 400;
    color: transparent;
    -webkit-text-stroke: thin rgba(255, 255, 255, 0.8);
    transform: translate(0, -100%);
    @include responsive_text_rems(768, 1920, 48, 120, 3.5, 6);
  }
  &__divider {
    span {
      position: absolute;
      top: 0;
      left: 62.5%;
      transform: translate(-50%, -100vh);
      display: inline-block;
      border-radius: 50%;
      border: 1px solid $color-white;
      display: block;
      height: 1.5rem;
      width: 1.5rem;
      &::before {
        position: absolute;
        bottom: 100%;
        left: 50%;
        width: 1px;
        height: 300vh;
        content: "";
        background: $color-white;
      }
    }
  }
}
@media (max-width: #{$breakpoint-large}) {
  .sidearm-mm-theme {
    &__title-text {
      transform: rotate(-90deg) translate(25%, -100%);
      font-size: 5.25rem;
      letter-spacing: 0.3em;
      padding-left: 0.3em;
      width: auto;
    }
    &__shoe {
      img {
        max-width: none;
        width: 120%;
      }
    }
    &__blur {
      img {
        max-width: none;
        width: auto;
        height: 120%;
      }
    }
    &__group,
    &__group-b {
      img {
        transform: translate(-50%, 200%);
      }
    }
  }
}
@media (max-width: #{$breakpoint-medium}) {
  .sidearm-mm-theme {
    &__shoe {
      img {
        width: 150%;
      }
    }
  }
}
</style>
